import type { OPSUserRoleVO } from "@/api/accounts/type";

import type { EntityType } from "./types";

/** 模板类型 → 页面实体类型 */
const TEMPLATE_TYPE_ENTITY_MAP: Record<string, EntityType> = {
  SUPPLIER: "supplier",
  AGENT: "agent",
  STORE: "store",
};

/**
 * 生成 OPS 角色列表项唯一键
 * @param role 接口返回的角色分组
 */
export const getOpsUserRoleKey = (role: OPSUserRoleVO) =>
  `${role.orgId}-${role.systemTypeCode}-${role.roleName}`;

/**
 * 从接口角色分组推导页面实体类型
 * @param role 接口返回的角色分组
 */
export const getEntityTypeFromOpsRole = (role: OPSUserRoleVO): EntityType => {
  if (role.systemTypeCode === "MEM") return "member";
  return TEMPLATE_TYPE_ENTITY_MAP[role.templateType] || "employee";
};

/**
 * 从角色分组取权限查询用 roleId
 * @param role 接口返回的角色分组
 */
export const getOpsUserRoleId = (role: OPSUserRoleVO) =>
  String(role.userRoleInfoList[0]?.roleId ?? "");
